"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Divider = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["classNames", "Component", "className"],
  _excluded2 = ["classNames", "label", "children", "variant", "size", "defaultClassName", "className", "TypographyProps", "classes", "inset", "fullWidth", "enableBackground"];
var defaultStyle = require("./../empty_css.js")["default"];
var Divider = exports.Divider = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useContext = (0, _react.useContext)(_context["default"]),
    _useContext$additiona = _useContext.additionalStyles,
    additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona,
    useStyle = _useContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? additionalStyles.menuItem || defaultStyle : _props$classNames,
    _props$Component = props.Component,
    Component = _props$Component === void 0 ? 'div' : _props$Component,
    className = props.className,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (classNames !== additionalStyles.menuItem) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({
    ref: ref
  }, rest, {
    className: (0, _clsx3["default"])(classNames.divider, className)
  }));
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useContext2 = (0, _react.useContext)(_context["default"]),
    _useContext2$addition = _useContext2.additionalStyles,
    additionalStyles = _useContext2$addition === void 0 ? {} : _useContext2$addition,
    useStyle = _useContext2.useStyle;
  var _props$classNames2 = props.classNames,
    classNames = _props$classNames2 === void 0 ? additionalStyles.menuItem || defaultStyle : _props$classNames2,
    _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    variant = props.variant,
    _props$size = props.size,
    size = _props$size === void 0 ? 'default' : _props$size,
    defaultClassName = props.defaultClassName,
    className = props.className,
    _props$TypographyProp = props.TypographyProps,
    TypographyProps = _props$TypographyProp === void 0 ? {} : _props$TypographyProp,
    _props$classes = props.classes,
    classes = _props$classes === void 0 ? {} : _props$classes,
    _props$inset = props.inset,
    inset = _props$inset === void 0 ? false : _props$inset,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? true : _props$fullWidth,
    _props$enableBackgrou = props.enableBackground,
    enableBackground = _props$enableBackgrou === void 0 ? false : _props$enableBackgrou,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  if (classNames !== additionalStyles.menuItem) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], Object.assign({
    ref: ref,
    variant: variant,
    size: 'menu-' + size,
    defaultClassName: (0, _clsx3["default"])(classNames.menuItem, (0, _defineProperty2["default"])({}, classNames.enableBackground, enableBackground), (0, _defineProperty2["default"])({}, classNames.inset, inset), defaultClassName),
    className: className,
    TypographyProps: (0, _objectSpread2["default"])({
      variant: variant === 'inline' ? 'menu-' + variant : 'menu-' + size
    }, TypographyProps),
    disableElevation: true,
    fullWidth: fullWidth,
    classes: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, classes), {}, {
      label: (0, _clsx3["default"])(classNames.label, classes.label),
      labelWidthSecondaryText: (0, _clsx3["default"])(classNames.labelWidthSecondaryText, classes.labelWidthSecondaryText),
      startIcon: (0, _clsx3["default"])(classNames.startIcon, classes.startIcon),
      endIcon: (0, _clsx3["default"])(classNames.endIcon, classes.endIcon),
      content: (0, _clsx3["default"])(classNames.content, classes.content)
    })
  }, rest, children ? {
    children: children,
    label: label
  } : {
    label: label
  }));
});